export const blockIconsHomeBlinds = (
	<span className='material-symbols-outlined'>blinds</span>
);
